export enum ResultTypeArrayCompare {
	ResultPerRecord,
	ArrayOfResults,
}
